import { NgModule, isDevMode } from '@angular/core';

import { AppComponent } from './app.component';
import { ScreenService, AppInfoService } from './shared/services';
import { UnauthenticatedContentComponent } from './unauthenticated-content';
import { AppRoutingModule, routes } from './app-routing.module';
import { ThemeService } from './shared/services/theme.service';
import { HttpClient } from '@angular/common/http';
import { CommonsService } from './shared/services/commons.service';
import { MessagesService } from './shared/services/messages.service';
import { MachineOwnerService } from './shared/services/owner.service';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MachineActivityServicee } from './shared/services/machine-activity.service';
import { TokenStorageService } from './shared/services/token-storage.service';
import { MachineMediumService } from './shared/services/machine-medium.service';
import { MachinePartInfoData } from './shared/services/machine-part-info.service';
import { MessagingService } from './shared/services/messaging.service';
import { ServiceDataService } from './shared/services/service-data.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NotAuthorizedContainerComponent } from './not-authorized-container';
import { AdministrationModule } from './pages/administration/administration.module';
import { ColaborationModule } from './pages/colaboration/colaboration.module';
import { CurrentMachineModule } from './pages/current-machine/current-machine.module';
import { MachineInfoModule } from './pages/machine-info/machine-info.module';
import { LayoutsModule } from './layouts/layouts.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { authInterceptorProviders, AuthModule, AuthService, ENVIRONMENT, LOGGED_USER_DETAIL_SVC, PipesModule, UNAUTHORIZED_REDIRECT_ROUTE } from 'acl-cloud-lib';
import { environment } from '../environments/environment';
import { AuthConfig } from 'angular-oauth2-oidc';
import { authConfig } from './core/auth/auth-config';
import { BASE_PATH } from '../api/generated';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DxButtonModule, DxCheckBoxModule, DxLoadPanelModule, DxPopupModule } from 'devextreme-angular';
import { AuthUserService } from 'acl-cloud-lib';
import { AuthUserServiceFakerService } from './shared/services/auth-user-service-faker.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HomeComponent } from './pages/home/home.component';

@NgModule({
  declarations: [
    AppComponent,
    NotAuthorizedContainerComponent,
    UnauthenticatedContentComponent,
    HomeComponent
  ],
  imports: [
    AdministrationModule,
    DxLoadPanelModule,
    ColaborationModule,
    CurrentMachineModule,
    MachineInfoModule,
    DxPopupModule,
    DxButtonModule,
    DxCheckBoxModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    AuthModule.forRoot(routes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    PipesModule,
    NgxSpinnerModule,
    LayoutsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    AuthService,
    ScreenService,
    AppInfoService,
    ThemeService,
    CommonsService,
    MessagesService,
    MachineOwnerService,
    MachineActivityServicee,
    TokenStorageService,
    MachineMediumService,
    MachinePartInfoData,
    MessagingService,
    ServiceDataService,
    authInterceptorProviders,
    { provide: ENVIRONMENT, useValue: environment },
    { provide: AuthConfig, useValue: authConfig},
    { provide: BASE_PATH, useValue: environment.baseUrl },
    { provide: UNAUTHORIZED_REDIRECT_ROUTE, useValue: '/dashboard'},
    { provide: LOGGED_USER_DETAIL_SVC, useClass: AuthUserServiceFakerService},
    AuthUserService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
